// TEAMS Website - Footer Component
// Site footer with contact info and links

import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../../styles/main.scss';

const Footer = () => {
  const { t } = useTranslation();

  // Social media links
  const socialLinks = [
    {
      name: 'Facebook',
      url: 'https://facebook.com',
      icon: 'fab fa-facebook-f'
    },
    {
      name: 'Instagram',
      url: 'https://instagram.com',
      icon: 'fab fa-instagram'
    },
    {
      name: 'YouTube',
      url: 'https://youtube.com',
      icon: 'fab fa-youtube'
    },
    {
      name: 'Whatsapp',
      url: 'https://wa.me/393201116789',
      icon: 'fab fa-whatsapp'
    }
  ];

  // Quick navigation links
  const quickLinks = [
    { path: '/', label: t('nav.home') },
    { path: '/association', label: t('nav.association') },
   // { path: '/events', label: t('nav.events') },
   // { path: '/press', label: t('nav.press') }
  ];

  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__content">
          {/* About section */}
          <div className="footer__section footer__section--about">
            <div className="footer__logo">
              <span className="footer__logo-text">TEAMS</span>
              <span className="footer__logo-subtitle">
                {t('hero.tagline')}
              </span>
            </div>
            <p className="footer__description">
              {t('mission.description')}
            </p>
            {/*
            <div className="footer__social">
              <h4 className="footer__social-title">{t('footer.follow.title')}</h4>
              <div className="footer__social-links">
                {socialLinks.map((social) => (
                  <a
                    key={social.name}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer__social-link"
                    aria-label={social.name}
                  >
                    <i className={social.icon}></i>
                  </a>
                ))}
              </div>
            </div>
            */}
          </div>

          <div className="footer__section footer__section--both">
            {/* Quick links */}
            <div className="footer__section footer__section--links">
              <h4 className="footer__section-title">Quick Links</h4>
              <ul className="footer__links">
                {quickLinks.map((link) => (
                  <li key={link.path}>
                    <Link to={link.path} className="footer__link">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact information */}
            <div className="footer__section footer__section--contact">
              <h4 className="footer__section-title">{t('footer.contact.title')}</h4>
              <div className="footer__contact-info">
                <div className="footer__contact-item">
                  <span className="footer__contact-label">{t('footer.contact.email')}</span>
                  <a href="mailto:info@teams-associazione.com" className="footer__contact-value">
                    info@teams-associazione.com
                  </a>
                </div>
                <div className="footer__contact-item">
                  <span className="footer__contact-label">{t('footer.contact.phone')}</span>
                  <a href="https://wa.me/393201116789" className="footer__contact-value">
                    (39) 320 111 6789
                  </a>
                </div>
                <div className="footer__contact-item">
                  <span className="footer__contact-label">{t('footer.contact.address')}</span>
                  <address className="footer__contact-value">
                    P.zza Don Chieppi, 1<br />
                    Busto Arsizio, Italia
                  </address>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="footer__bottom">
          <div className="footer__bottom-content">
            <p className="footer__copyright">
              &copy; {currentYear} TEAMS. {t('footer.legal.copyright').replace('© 2024 TEAMS. ', '')}
            </p>
            <div className="footer__legal-links">
              <Link to="/privacy" className="footer__legal-link">
                {t('footer.legal.privacy')}
              </Link>
              <Link to="/terms" className="footer__legal-link">
                {t('footer.legal.terms')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
